/* OGs Cart-Drawer Newsletter (Lenny) – delegiert, übersteht Drawer-Re-Render */
(function () {
  if (window.__ogsCartNl) return; window.__ogsCartNl = true;
  var KEY = 'ogsCartNlDone';
  function store() { try { return window.sessionStorage; } catch (e) { return null; } }
  function box(form) { return form && form.closest('[data-ogs-cart-nl]'); }
  function msg(form, text, ok) {
    var el = form.querySelector('.ogs-cart-nl__msg'); if (!el) return;
    el.textContent = text || ''; el.className = 'ogs-cart-nl__msg ' + (ok ? 'ogs-cart-nl__msg--ok' : 'ogs-cart-nl__msg--err');
  }
  function busy(form, on) { var b = form.querySelector('.ogs-cart-nl__btn'); if (b) b.disabled = !!on; }
  function done(b) {
    if (!b || b.classList.contains('is-done')) return;
    b.classList.add('is-done'); b.classList.remove('is-collapsed');
    var f = b.querySelector('form'); if (f) msg(f, '', true);
    var ok = b.querySelector('.ogs-cart-nl__ok'); if (ok) ok.hidden = false;
  }
  function applyOpen() {
    var s = store(); if (!s || s.getItem('ogsCartNlOpen') !== '1') return;
    document.querySelectorAll('[data-ogs-cart-nl].is-collapsed').forEach(function (b) { b.classList.remove('is-collapsed'); });
  }
  /* Kompakt-Drawer: "+X weitere Artikel" Hinweis, wenn Artikel unterhalb des sichtbaren Bereichs liegen */
  var moreRaf = 0;
  function updateMore() {
    moreRaf = 0;
    document.querySelectorAll('[data-ogs-more]').forEach(function (m) {
      var sc = m.closest('cart-drawer-items'); if (!sc) { m.hidden = true; return; }
      var r = sc.getBoundingClientRect(); var n = 0;
      if (r.height > 0) sc.querySelectorAll('.cart-item').forEach(function (it) { var ir = it.getBoundingClientRect(); if (ir.bottom > r.bottom + 2) n++; });
      if (!n) { m.hidden = true; return; }
      var t = (n === 1 ? m.getAttribute('data-one') : m.getAttribute('data-other')) || '+{n}';
      var btn = m.querySelector('button'); if (btn) btn.textContent = t.replace('{n}', n);
      m.hidden = false;
    });
  }
  function schedMore() { if (!moreRaf) moreRaf = requestAnimationFrame(updateMore); }
  document.addEventListener('scroll', function (e) { if (e.target && e.target.tagName === 'CART-DRAWER-ITEMS') schedMore(); }, true);
  window.addEventListener('resize', schedMore);
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG' && e.target.closest('#CartDrawer')) schedMore(); }, true);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedMore);
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.ogs-cart-nl__teaser');
    if (t) {
      var b = t.closest('[data-ogs-cart-nl]'); if (b) b.classList.remove('is-collapsed');
      t.setAttribute('aria-expanded', 'true');
      var s0 = store(); if (s0) s0.setItem('ogsCartNlOpen', '1');
      var inp = b && b.querySelector('input[type=email]'); if (inp) setTimeout(function () { inp.focus(); }, 30);
      schedMore(); return;
    }
    var mb = e.target.closest && e.target.closest('[data-ogs-more] button');
    if (mb) { var sc = mb.closest('cart-drawer-items'); if (sc) sc.scrollBy({ top: Math.max(120, sc.clientHeight * 0.8), behavior: 'smooth' }); }
  });
  function applyDone() {
    applyOpen(); schedMore(); setTimeout(schedMore, 400); setTimeout(schedMore, 1200);
    var s = store(); if (!s) return;
    if (s.getItem(KEY) === '1') { document.querySelectorAll('[data-ogs-cart-nl]').forEach(done); return; }
    var em = s.getItem(ERR);
    if (em !== null && !window.__ogsNlSubmitting) document.querySelectorAll('#OgsCartNewsletter').forEach(function (f) {
      var m = f.querySelector('.ogs-cart-nl__msg'); if (m && !m.textContent) showErr(f, em);
    });
  }
  /* Newsletter-Fix (Lenny, 23.10.2026): kein iframe mehr. Shopify-Seiten verbieten Framing (X-Frame-Options: DENY),
     darum konnte das iframe-Ergebnis nie gelesen werden. Jetzt normales Absenden als ganze Seite; hCaptcha/Challenge
     laufen wie bei jedem Shopify-Formular. Ergebnis wird nach dem Redirect in init() ausgewertet. */
  var PEND = 'ogsCartNlPending', ERR = 'ogsCartNlErr', MARK = 'ogs_nl';
  function cleanSearch(search) {
    var q = (search || '').replace(/^\?/, '').split('&').filter(function (p) {
      return p && !/^(customer_posted|contact_posted|ogs_nl|form_type)=/.test(p);
    });
    return q.length ? '?' + q.join('&') : '';
  }
  function returnTo() {
    var q = cleanSearch(location.search);
    return location.pathname + (q ? q + '&' : '?') + MARK + '=1';
  }
  function showErr(form, text) {
    var b = box(form); if (!b) return;
    b.classList.remove('is-collapsed');
    msg(form, text || b.getAttribute('data-msg-err'), false);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'OgsCartNewsletter') return;
    var b = box(form), email = form.querySelector('input[type=email]');
    if (!email || !email.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      e.preventDefault(); e.stopImmediatePropagation();
      msg(form, b && b.getAttribute('data-msg-invalid'), false); return;
    }
    email.value = email.value.trim();
    form.removeAttribute('target');
    var rt = form.querySelector('[data-ogs-nl-return]') || form.elements['return_to'];
    if (rt) rt.value = returnTo();
    var s = store(); if (s) { s.setItem(PEND, String(Date.now())); s.removeItem(ERR); }
    window.__ogsNlSubmitting = true;
    msg(form, '', true); busy(form, true);
    /* hCaptcha kann eine Bestätigung verlangen: Button nach 15 s wieder freigeben, falls abgebrochen */
    setTimeout(function () { busy(form, false); window.__ogsNlSubmitting = false; }, 15000);
  }, true);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'OgsCartNewsletter-Email') { var s = store(); if (s) s.removeItem(ERR); }
  });
  /* Code antippen = kopieren */
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-ogs-copy]'); if (!c) return;
    var code = c.getAttribute('data-ogs-copy'), hint = c.querySelector('.ogs-cart-nl__code-hint');
    function ok() { if (hint) hint.textContent = c.getAttribute('data-copied') || '✓'; }
    try { navigator.clipboard.writeText(code).then(ok, function () {}); } catch (err) {}
  });
  function openDrawer() {
    function go() {
      var cd = document.querySelector('cart-drawer');
      if (cd && typeof cd.open === 'function' && !cd.classList.contains('is-empty')) setTimeout(function () { try { cd.open(); } catch (e) {} }, 300);
    }
    try { if (window.customElements && customElements.whenDefined) { customElements.whenDefined('cart-drawer').then(go); return; } } catch (e) {}
    window.addEventListener('load', go);
  }
  function checkResult() {
    /* Rückkehr nach dem Absenden (ggf. über Shopify-hCaptcha-Challenge): Erfolg oder Fehler erkennen */
    try {
      var s = store(), search = location.search || '', hash = location.hash || '';
      var pend = s && Number(s.getItem(PEND) || 0);
      if (pend && Date.now() - pend > 30 * 60 * 1000) { s.removeItem(PEND); pend = 0; }
      var form = document.getElementById('OgsCartNewsletter');
      var st = form && form.querySelector('[data-ogs-nl-state]');
      var srv = st ? st.getAttribute('data-ogs-nl-state') : '';
      var srvErr = st ? st.getAttribute('data-ogs-nl-srv-err') : '';
      /* Shopify-Challenge-Seite (/challenge?form_key=…&return_path=…): noch kein Ergebnis – Merker behalten, erst auf der nächsten Seite auswerten */
      if (/\/challenge\/?$/.test(location.pathname) || (/[?&]form_key=/.test(search) && /[?&]return_path=/.test(search))) return;
      var posted = /[?&]customer_posted=true/.test(search);
      var hashOurs = hash === '#OgsCartNewsletter';
      var mark = new RegExp('[?&]' + MARK + '=1').test(search);
      var ours = hashOurs || mark || !!pend;
      if (!ours) return;
      /* Erfolg: customer_posted=true / Server-Status ok (auch nach Challenge, dort ohne ogs_nl) – oder unser return_to-Merker bei offenem Absenden */
      var ok = srv !== 'err' && (posted || srv === 'ok' || (mark && !!pend));
      var err = !ok && (srv === 'err' || (!!pend && (hashOurs || /[?&]contact_posted=/.test(search))));
      if (!ok && !err) return; /* z. B. Captcha abgebrochen: nichts anzeigen */
      if (s) s.removeItem(PEND);
      if (ok) {
        if (s) { s.setItem(KEY, '1'); s.removeItem(ERR); }
        try { document.dispatchEvent(new CustomEvent('ogs:newsletter-subscribed', { detail: { source: 'cart-drawer' } })); } catch (e) {}
      } else if (s) {
        s.setItem(ERR, srvErr || '');
      }
      /* Adresse aufräumen, damit ein Reload nichts erneut auslöst */
      try { history.replaceState(history.state, '', location.pathname + cleanSearch(search)); } catch (e) {}
      openDrawer();
    } catch (e) {}
  }
  function init() {
    checkResult(); applyDone();
    var d = document.querySelector('cart-drawer');
    if (d && window.MutationObserver) new MutationObserver(applyDone).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    if (d) d.addEventListener('transitionend', schedMore);
  }
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    window.__ogsNlSubmitting = false;
    document.querySelectorAll('#OgsCartNewsletter').forEach(function (f) { busy(f, false); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
